<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <error-msg-component :messages="messagesPopup"
                           :error="isErrorPopup"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="isErrorPopup = $event"/>
      <section class="has-text-centered">
        <b-icon type="is-warning" icon="alert-outline" class="icon-modal"></b-icon>
        <p class="is-size-5 has-text-weight-bold">
          {{ messageHeader }}
        </p>
      </section>
      <section class="mgt-10px">
        <b-field :label="getLabelDate"
          v-if="isDisplayDate"
          class="mgt-20px obligatoire">
          <b-datepicker show-week-number
            icon="calendar-today"
            :editable="true"
            nearby-selectable-month-days
            v-model="date">
          </b-datepicker>
        </b-field>
        <qd-switch v-if="isRealiserActionIntervention"
                  v-model="realiserActionIntervention" class="mgt-10px">
          {{ $t('detailOrdreTravailTech.popup.actionIntervationTypeOt',
            { ActionInterventionOtType:
               getActionInterventionLibelle(ordreTravail.typeOt.actionInterventionOt)}) }}
        </qd-switch>
        <qd-switch v-if="isAnnulatonSuppression" v-model="annulatonSuppression"  class="mgt-5px">
          {{ ordreTravail.typeOt.actionInterventionOt === constantes.MONTAGE
                ? $t('detailOrdreTravailTech.popUpSuppression.demonter')
                : $t('detailOrdreTravailTech.popUpSuppression.monter') }}
        </qd-switch>
        <br/>
        <qd-switch v-if="isImpactEtatDemandes" v-model="impactEtatDemandes"  class="mgt-5px">
          {{ isImpactEtatDemandes ? $t('detailOrdreTravailTech.popup.updateDemande')
            :  $t('detailOrdreTravailTech.popup.actionAnnulationImpactEtatDemande') }}
        </qd-switch>
      </section>
      <footer class="mgt-10px">
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$emit('close')">
            {{ $t('general.button.cancel') }}
          </button>
          <button class="button is-addOrEdit has-text-centered button-modal"
                  @click="updateEtat">
            {{ $t('general.button.valider') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';
import {
  ETAT_REALISE,
  ETAT_PLANIFIE,
  ETAT_ANNULE,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import {
  AUCUN,
  MONTAGE,
  DEMONTAGE,
  LISTE_ACTION_INTERVENTION,
  LISTE_ACTION_INTERVENTION_DISPOSITF,
  IMPRESSION_AFFICHE,
} from '@/configuration/logistique/typeOt/typeOtConfig';
import { ETAT_TRAITE } from '@/configuration/logistique/intervention/interventionConf';
import changerEtatOtTechnique from '@/services/logistique/ordreTravail/tech/changerEtatOtTechnique';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import validation from '@/services/logistique/ordreTravail/tech/validation/validation';
import formatDate from '@/services/general/formatIsoDate';

export default {
  components: {
    errorMsgComponent,
  },
  props: {
    ordreTravail: {
      type: Object,
      required: true,
    },
    etatAchanger: {
      type: String,
      required: true,
    },
    messageHeader: {
      type: String,
      required: true,
    },
    moduleEmplacementClientActive: {
      type: Boolean,
      default: false,
    },
    otIdsFromActionGroupe: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      messagesPopup: [],
      isErrorPopup: false,
      date: null,
      constantes: {
        ETAT_PLANIFIE,
        MONTAGE,
        ETAT_REALISE,
      },
      realiserActionIntervention: false,
      impactEtatDemandes: false,
      annulatonSuppression: false,
    };
  },
  computed: {
    getLabelDate() {
      if (this.etatAchanger === ETAT_REALISE) return this.$t('detailOrdreTravailTech.popup.dateRealisation');
      return this.$t('detailOrdreTravailTech.popup.datePlanification');
    },
    isRealiserActionIntervention() {
      return (this.etatAchanger === ETAT_REALISE
        && !!this.ordreTravail.otPatrimoine
        && this.ordreTravail.typeOt.actionInterventionOt !== AUCUN
        && this.ordreTravail.typeOt.actionInterventionOt !== IMPRESSION_AFFICHE);
    },
    isImpactEtatDemandes() {
      if (!this.ordreTravail.demandesLogistique) return false;
      if (this.etatAchanger === ETAT_REALISE) {
        return this.ordreTravail.demandesLogistique.length > 0
        && this.ordreTravail.demandesLogistique.find((d) => { return d.etat !== ETAT_TRAITE; })
            !== undefined;
      }
      if (this.etatAchanger === ETAT_ANNULE) {
        return this.ordreTravail.demandesLogistique.length > 0;
      }
      return false;
    },
    isAnnulatonSuppression() {
      return this.etatAchanger === ETAT_ANNULE && this.ordreTravail.otPatrimoine !== null
            && (this.ordreTravail.typeOt.actionInterventionOt === MONTAGE
            || this.ordreTravail.typeOt.actionInterventionOt === DEMONTAGE);
    },
    isDisplayDate() {
      return (this.etatAchanger === ETAT_REALISE && !this.ordreTravail.dateRealisation)
        || (this.etatAchanger === ETAT_PLANIFIE && !this.ordreTravail.datePlanification);
    },
  },
  methods: {
    async updateEtat() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.messagesPopup = [];
        this.isErrorPopup = false;
        const otsIds = this.otIdsFromActionGroupe !== null
          ? this.otIdsFromActionGroupe : [this.ordreTravail.id];
        await changerEtatOtTechnique(
          otsIds,
          this.etatAchanger,
          this.realiserActionIntervention,
          this.impactEtatDemandes,
          this.annulatonSuppression,
          formatDate(this.date),
        );
        messageSucces(this.$i18n.t(this.otIdsFromActionGroupe !== null ? 'listeExpedition.messages.success.otExpedie' : 'detailOrdreTravailTech.messages.changer.success'));
        this.$emit('update');
        loadingComponent.close();
      } catch (e) {
        if (e.response.data.error) {
          validation(e.response, this.messagesPopup, []);
          this.isErrorPopup = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getActionInterventionLibelle(typeOtAction) {
      let listeAction = LISTE_ACTION_INTERVENTION;
      if (this.moduleEmplacementClientActive) {
        listeAction = listeAction.concat(LISTE_ACTION_INTERVENTION_DISPOSITF);
      }

      const actionFind = listeAction.find((actionInter) => {
        return actionInter.code === typeOtAction;
      });
      return actionFind ? this.$i18n.t(actionFind.libelle) : '';
    },
  },
  mounted() {
    switch (this.etatAchanger) {
      case ETAT_ANNULE:
        this.annulatonSuppression = this.isAnnulatonSuppression;
        this.impactEtatDemandes = this.isImpactEtatDemandes;
        break;
      case ETAT_PLANIFIE:
        this.date = this.ordreTravail.datePlanification
          ? new Date(this.ordreTravail.datePlanification) : null;
        break;
      case ETAT_REALISE:
        this.date = this.ordreTravail.dateRealisation
          ? new Date(this.ordreTravail.dateRealisation) : null;
        this.realiserActionIntervention = this.isRealiserActionIntervention;
        this.impactEtatDemandes = this.isImpactEtatDemandes;
        break;
      default:
        break;
    }
  },
};
</script>

<style>

</style>
